import React, { useState } from "react";
import "../styles/DigitalProjectsGrid.scss";

// Helper function to import all images dynamically
const importAll = (requireContext) => requireContext.keys().map(requireContext);

// Dynamically load images
const digitalProjectImages = importAll(
  require.context("../assets/digital_projects_images", false, /\.(png|jpe?g|svg)$/)
);

const DigitalProjectsGrid = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => setSelectedImage(image);

  const closeLightbox = () => setSelectedImage(null);

  // Descriptive text
  const descriptiveText = (
    <div className="grid-item-text" key="descriptive-text">
      <p>A range of digital designs created for online campaigns, websites, social media, and other digital platforms. These projects focus on delivering clear, engaging visuals tailored for the digital space.</p>
    </div>
  );

  // Arrange grid items with descriptive text in the center for desktop
  const midpoint = Math.floor(digitalProjectImages.length / 2);
  const gridItems = [
    ...digitalProjectImages.slice(0, midpoint).map((src, index) => (
      <div
        key={`image-${index}`}
        className="digital-projects-item"
        onClick={() => handleImageClick(src)}
      >
        <img src={src} alt={`Digital Project ${index + 1}`} />
      </div>
    )),
    descriptiveText,
    ...digitalProjectImages.slice(midpoint).map((src, index) => (
      <div
        key={`image-${midpoint + index}`}
        className="digital-projects-item"
        onClick={() => handleImageClick(src)}
      >
        <img src={src} alt={`Digital Project ${midpoint + index + 1}`} />
      </div>
    )),
  ];

  return (
    <div>
      <div className="digital-projects-grid">
        {gridItems}
      </div>

      {/* Lightbox functionality */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeLightbox}>
              &times;
            </button>
            <img src={selectedImage} alt="Selected Digital Project" />
          </div>
        </div>
      )}

      {/* Uncomment for mobile-specific functionality */}
      {/* const isMobile = useDeviceType() === "mobile"; */}
      {/* Adjust gridItems logic here for mobile-first text placement */}
    </div>
  );
};

export default DigitalProjectsGrid;
